module.exports = __webpack_public_path__ + "media/promo/hochland/images/ball5-26d7024b06b9dbb7adbfdb10669e6338.png";